import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { combineLatest, map } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import {
  createFlightLog,
  createLogEntry,
  createWaypoint,
  DefaultLogMode,
  isLogMode,
  LogMode,
  LogStatus,
} from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.model';
import { CrewRole } from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { FlightLogEntity } from 'src/store/flight-log/flight-log.model';
import { uuid } from 'src/util/uuid';
import { UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-create-flight-log-page',
  templateUrl: './create-flight-log-page.component.html',
  styleUrls: ['./create-flight-log-page.component.scss'],
})
export class CreateFlightLogPageComponent implements OnInit {
  public flightLog$: Observable<FlightLogEntity>;
  constructor(@Inject(USER) private user: UserViewModel, private route: ActivatedRoute) {}

  public ngOnInit() {
    this.flightLog$ = this.route.queryParams.pipe(
      map((p) => p.mode),
      // eslint-disable-next-line import/no-deprecated
      combineLatest(this.route.queryParams.pipe(map((p) => p.dispatchId))),
      map(([flightModeParam, dispatchIdParam]) => {
        const mode: LogMode = isLogMode(flightModeParam) ? flightModeParam : DefaultLogMode;
        // this.snackBar.open(message, null, { duration: 3000 });
        const flightLog = createFlightLog(mode);
        const flightCrewId = uuid();
        flightLog.flightSummaryId = dispatchIdParam;
        flightLog.flightCrew = [
          {
            employeeId: this.user.id,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            id: flightCrewId,
            role: CrewRole.PilotInCommand,
          },
        ];
        flightLog.status = LogStatus.Draft;
        if (mode === 'EntryPerLeg') {
          const w1 = createWaypoint();
          const w2 = createWaypoint();
          flightLog.waypoints = [w1, w2];
          flightLog.entries[0] = createLogEntry(w1.id, w2.id);
        } else {
          flightLog.entries[0] = createLogEntry(null, null);
        }

        flightLog.entries[0].entryDetail.crewOnboard.push({
          flightCrewId,
          isNvg: false,
          hnvgo: null,
        });
        return flightLog;
      }),
    );
  }
}
